const VERSION = '3.2.2';
export function getVersionString() {
    return VERSION;
}
